import type { FunctionComponent } from 'react'
import React from 'react'
import { useTableContext } from '../Context'
import type { HeaderRowConfig } from '../types'
import map from 'lodash/map'
import { ActionHeaderCell } from './ActionHeaderCell'
import { MenuHeaderCell } from './MenuHeaderCell'

export const TableHeader = () => {
  const { listFields, head } = useTableContext()

  const HeadRow: FunctionComponent<HeaderRowConfig> = head
  const renderDataHeaderCell = () => {
    //we need to loop here for all list fields and render them using the HeaderCell
    const actionCells = map(listFields, (m) => (
      <ActionHeaderCell key={m.name} field={m}>
        {m.displayName}
      </ActionHeaderCell>
    ))

    const menuHeaderCell = head ? undefined : <MenuHeaderCell key={'menu-header-cell'} />
    return [menuHeaderCell, ...actionCells]
  }

  //if there is no value for head we render the default
  return (
    <thead>
      <tr>
        {head ? <HeadRow _fields={listFields} _renderDataHeaderCell={renderDataHeaderCell} /> : renderDataHeaderCell()}
      </tr>
    </thead>
  )
}
